import { Icon } from "@mui/material";
import BMXButton from "../Buttons/BMXButton/BMXButton";
import "./PrintDocumentTemplate.scss";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import { useEffect, useRef, useState } from "react";
import html2pdf from "html-to-pdf-js";
import { saveFilesAsZip } from "../../Utils/Attachments/Attachments";
import { PDFDocument } from 'pdf-lib';
import { exportToXLSX } from "../../Utils/Excel/excelUtils";


const PrintDocumentTemplate = (props) => {
  const { additionalButtons, usersToSendEmail, fileName, children, printDataOptimaId, dataToXls, colorRanges = [], optimaCheckBox = false, documentType } = props;
  const currentRef = useRef();


  const [childrenArray, setChildrenArray] = useState([]);

  const dispatch = useDispatch();
  const showModal = () => {
    return dispatch(
      show("printDocumentEmailModal", { usersToSendEmail, getDocumentFile, optimaCheckBox: optimaCheckBox, printDataOptimaId, documentType:documentType })
    );
  };

  const opt = {
    filename: fileName || "document",
    image: { type: 'jpeg', quality: 1 },
  };

  const getDocumentFile = async () => {


    const _data = await exportToXLSX(dataToXls, colorRanges, "Wszystkie ceny w PLN netto.")

    const fileXlsx = { data: _data, name: opt.filename?.split(":")?.at(-1)?.replaceAll("/", "_")?.trim() + ".xlsx" };

    const printAreas = [...document.querySelectorAll(".PrintArea")];
    if (printAreas.length <= 1) {
      return new Promise((res) => {
        html2pdf()
          .from(printAreas.at(-1))
          .set(opt)
          .toPdf()
          .output("blob")
          .then(async (data) => {
            const blob = new Blob([data], { type: "application/pdf" });
            const file = new File([blob], `${opt.filename}.pdf`);
            const filePDF = { data: file, name: opt.filename?.split(":")?.at(-1)?.replaceAll("/", "_")?.trim() + ".pdf" };

            const filesToZip = [filePDF];
            if (Boolean(dataToXls)) {
              filesToZip.push(fileXlsx)
            }

            const blobToSend = await saveFilesAsZip(filesToZip, opt.filename, true);
            res(blobToSend);
          });
      })
    }

    return new Promise(async (res) => {
      let dataArray = new ArrayBuffer();
      for (const doc of printAreas) {
        await html2pdf()
          .from(doc)
          .set(opt)
          .toPdf()
          .output("blob")
          .then(async (data) => {
            const arrBuff = await data.arrayBuffer();
            if (dataArray.byteLength <= 0) {
              dataArray = arrBuff;
              return;
            }
            dataArray = await mergePdfBuffers(dataArray, arrBuff);
          });
      }
      const blob = new Blob([dataArray], { type: "application/pdf" });
      const file = new File([blob], `${opt.filename}.pdf`);
      const filePDF = { data: file, name: opt.filename?.split(":")?.at(-1)?.replaceAll("/", "_")?.trim() + ".pdf" };
      const filesToZip = [filePDF];
      if (Boolean(dataToXls)) {
        filesToZip.push(fileXlsx)
      }
      const blobToSend = await saveFilesAsZip(filesToZip, opt.filename, true);
      res(blobToSend);
    })
  };

  const onPrint = async () => {
    const printAreas = [...document.querySelectorAll(".PrintArea")];
    if (printAreas.length <= 1) {
      await html2pdf()
        .from(printAreas.at(-1))
        .set(opt)
        .toPdf()
        .output("blob")
        .then((data) => {
          const blob = new Blob([data], { type: "application/pdf" });
          const blobURL = URL.createObjectURL(blob);

          const iframe = document.createElement("iframe");
          document.body.appendChild(iframe);

          iframe.style.display = "none";
          iframe.src = blobURL;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        });
      return;
    }

    let dataArray = new ArrayBuffer();
    for (let doc of printAreas) {
      await html2pdf()
        .from(doc)
        .set(opt)
        .toPdf()
        .output("blob")
        .then(async (data) => {
          const arrBuff = await data.arrayBuffer();
          if (dataArray.byteLength <= 0) {
            dataArray = arrBuff;
            return;
          }
          dataArray = await mergePdfBuffers(dataArray, arrBuff);
        });
    }
    const blob = new Blob([dataArray], { type: "application/pdf" });
    const blobURL = URL.createObjectURL(blob);
    const iframe = document.createElement("iframe");
    document.body.appendChild(iframe);

    iframe.style.display = "none";
    iframe.src = blobURL;
    iframe.onload = function () {
      setTimeout(function () {
        iframe.focus();
        iframe.contentWindow.print();
      }, 1);
    };

  };

  async function mergePdfBuffers(buffer1, buffer2) {
    if (!(buffer1 instanceof ArrayBuffer) || !(buffer2 instanceof ArrayBuffer)) {
      throw new Error('Oczekiwano typu ArrayBuffer');
    }

    const pdfDoc = await PDFDocument.create();

    const pdf1 = await PDFDocument.load(buffer1);
    const pdf2 = await PDFDocument.load(buffer2);

    const copiedPages1 = await pdfDoc.copyPages(pdf1, pdf1.getPageIndices());
    copiedPages1?.forEach((page) => pdfDoc.addPage(page));

    const copiedPages2 = await pdfDoc.copyPages(pdf2, pdf2.getPageIndices());
    copiedPages2?.forEach((page) => pdfDoc.addPage(page));

    const mergedBytes = await pdfDoc.save();
    return await new Blob([mergedBytes], { type: "application/pdf" }).arrayBuffer();
  }

  const onDownload = async () => {


    const _data = await exportToXLSX(dataToXls, colorRanges, "Wszystkie ceny w PLN netto.")

    const fileXlsx = { data: _data, name: opt.filename?.split(":")?.at(-1)?.replaceAll("/", "_")?.trim() + ".xlsx" };

    const printAreas = [...document.querySelectorAll(".PrintArea")];

    if (printAreas.length <= 1) {
      const element = printAreas.at(-1);
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .output("blob")
        .then(async (dataPDF) => {
          const blob = new Blob([dataPDF], { type: "application/pdf" });
          const file = new File([blob], opt.filename?.split(":")?.at(-1)?.replaceAll("/", "_")?.trim() + ".pdf")
          const filePDF = { data: file, name: opt.filename?.split(":")?.at(-1)?.replaceAll("/", "_")?.trim() + ".pdf" };

          const filesToZip = [filePDF];
          if (Boolean(dataToXls)) {
            filesToZip.push(fileXlsx)
          }

          saveFilesAsZip(filesToZip, opt.filename)
        });

      return;
    }

    let dataArray = new ArrayBuffer();

    for (const doc of printAreas) {
      await html2pdf()
        .from(doc)
        .set(opt)
        .toPdf()
        .output("blob")
        .then(async (data) => {
          const arrBuff = await data.arrayBuffer();
          if (dataArray.byteLength <= 0) {
            dataArray = arrBuff;
            return;
          }
          dataArray = await mergePdfBuffers(dataArray, arrBuff);
        });
    }
    const blob = new Blob([dataArray], { type: "application/pdf" });
    const file = new File([blob], opt.filename?.split(":")?.at(-1)?.replaceAll("/", "_")?.trim() + ".pdf")
    const filePDF = { data: file, name: opt.filename?.split(":")?.at(-1)?.replaceAll("/", "_")?.trim() + ".pdf" };

    const filesToZip = [filePDF];
    if (Boolean(dataToXls)) {
      filesToZip.push(fileXlsx)
    }
    saveFilesAsZip(filesToZip, opt.filename)

  };

  useEffect(() => {
    const cnt = 50;
    let tmp = [];
    for (let i = 0; i < children.length; i += cnt) {
      const x = children.length > i + cnt ? i + cnt : children.length
      tmp.push(children.slice(i, x));
    }
    setChildrenArray(tmp);
  }, [])


  return (
    <div className="PrintDocument" ref={currentRef}>
      {childrenArray.map((el) =>
        <div className="PrintArea">
          {el?.length > 0 ? (
            el.filter(el => Boolean(el)).map((child) => <div className="PrintCard">{child}</div>)
          ) : (
            <div className="PrintCard">{el}</div>
          )}
        </div>
      )}
      <div className="PrintDocumentButtonsButtonsArea">
        {additionalButtons}
        <BMXButton onClick={onDownload} bmxclass="Success" buttontype="Fab">
          <Icon>file_download_outlined_icon</Icon>
        </BMXButton>
        <BMXButton onClick={onPrint} bmxclass="Success" buttontype="Fab">
          <Icon>local_printshop_outlined</Icon>
        </BMXButton>
        {usersToSendEmail && (
          <BMXButton bmxclass="Success" onClick={showModal} buttontype="Fab">
            <Icon>forward_to_inbox_outlined</Icon>
          </BMXButton>
        )}
      </div>
    </div>
  );
};

export default PrintDocumentTemplate;
